import { Preloader } from '../../components/Chart'
import BorderButton from '../../components/BorderButton'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { push } from 'connected-react-router'

import PageWrapper from '../../components/PageWrapper'
import LicenseList from '../../components/LicenseList'
import WhiteBox from '../../components/WhiteBox'
import axios from 'axios'

import debounce from 'lodash/debounce'

import ReactTooltip from 'react-tooltip'
import { isAdmin } from '../../lib/check-user'
import ACLCheckPermission from '../../components/ACLCheckPermission'
import UserRolesService from '../../lib/services/userRole/UserRolesService'

import { CSVDownload } from 'react-csv'
import XLSX from 'xlsx'


class License extends Component {
    debouncedFilter = null

    state = {
        size: 20,
        offset: 0,
        filter: '',
        sort: 'creation',
        sortOrder: 'desc',
        licenses: [],
        showEdit: true,
        csvData: null,

    }
    onFilterChange(target) {
        console.log('onFilterChange', target.value, this)
        let offset = 0
        this.setState({ offset: offset, filter: target.value })
        this.debouncedFilter(target.value, this.state.size, offset, true, this.state.sort, this.state.sortOrder)
    }
    onHistory(license) {
        this.props.history.push('/events?objectId=' + license.licenseId + '&eventType=LICENSE')
    }
    onLoadMore() {
        let offset = this.state.offset + this.state.size
        this.setState({ offset: offset })
        this.debouncedFilter(this.state.filter, this.state.size, offset, false, this.state.sort, this.state.sortOrder)
    }
    onSortChange(sortField) {
        console.log('on sort change', sortField, this)
        let sort = this.state.sort
        let sortOrder = this.state.sortOrder
        if (sort != sortField) {
            sortOrder = 'asc'
        } else {
            // toggle if is the same field
            sortOrder = sortOrder == 'asc' ? 'desc' : 'asc'
        }
        sort = sortField
        let offset = 0
        this.setState({ sort: sort, sortOrder: sortOrder, offset: offset })
        this.debouncedFilter(this.state.filter, this.state.size, offset, true, sort, sortOrder)
    }
    componentDidMount() {
        let search = window.location.search
        let params = new URLSearchParams(search)
        console.log('events query params', params, params.get('filter'))
        this.setState(
            {
                filter: params.get('filter') || ''
            },
            () => {
                this.fetchLicenses(this.state.filter, this.state.size, this.state.offset, true, this.state.sort, this.state.sortOrder)
                this.debouncedFilter = debounce(this.fetchLicenses, 300)
            }
        )

        // check if the user can see edit column
        let userService = new UserRolesService()
        userService.isEnabled('/license', 'PATCH').then(active => {
            this.setState({ showEdit: active })
        })
    }

    fetchLicenses(filter = '', size = 20, offset = 0, clear = false, sort = 'audienceName', sortOrder = 'asc') {
        console.log('fetchLicenses', clear)
        const query = `/license?offset=${offset}&size=${size}&filter=${filter}&sort=${sort}&sortOrder=${sortOrder}`
        this.setState({ loading: true }, () => {
            axios.get(query).then(response => {
                let newLicenses = response.data.body
                let oldLicenses = []
                if (!clear) {
                    oldLicenses = this.state.licenses
                }
                oldLicenses = oldLicenses.concat(newLicenses)
                this.setState({ licenses: oldLicenses, loading: false })
            })
        })
    }

    onEditLicense(license) {
        this.props.history.push({
            pathname: `/licenses/edit/${license.licenseId}`,
            state: { license: license }
        })
    }


    // 
    // Export XLS
    //

    mapDataToCSV(list) {
        let csvData = []
        for (var i = 0; i < list.length; i++) {
            csvData.push({
                'licenseId': list[i]['licenseId'],
                'licenseName': list[i]['licenseName'],
                'audienceId': list[i]['audienceId'],
                'audienceName': list[i]['audienceName'],
                'cookieDuration': list[i]['cookieDuration'],
                'cpmCost': list[i]['cpmCost'],
                'currency': list[i]['currency'],
                'dmp': list[i]['dmp'],
                'dmpClientId': list[i]['dmpClientId'],
                'dmpProductId': list[i]['dmpProductId'],
                'dmpSegmentId': list[i]['dmpSegmentId'],
                'partnerId': list[i]['partnerId'],
                'status': list[i]['status'],
                'validUntil': list[i]['validUntil'],
                'creation': list[i]['creation'],
            })
        }
        return csvData
    }

    onCSVExport() {
        this.setState({ loading: true, csvData: null }, () => {
            
            axios.get("/license/count").then(response=>{
                let count = response.data.body
                console.log("got max count", count)

                 // paginate through a MAX of 20k licenses exported
                const maxExported = count;
                const maxLimit = 1000;
                let requests = [];
                for(let i = 0; i <= maxExported; i += maxLimit){ 
                    let url = `/license?offset=${i}&size=${maxLimit}&filter=${this.state.filter}&sort=${this.state.sort}&sortOrder=${this.state.sortOrder}`
                    requests.push( axios.get(url) )
                }
                let jsonData = []
                axios.all(requests).then(axios.spread((...responses) => {
                    for(let i=0 ; i < responses.length; i++ ){ 
                        let response = responses[i];
                        //console.log("got response ", i, ", resp ", response)
                        let tmpJsonData = this.mapDataToCSV(response.data.body)
                        //console.log("got mapped ", tmpJsonData)
                        if(tmpJsonData && tmpJsonData.length > 0)
                            jsonData = jsonData.concat(tmpJsonData)
                    }
                    console.log("processed all json ", jsonData.length)

                    this.setState({
                        loading: false
                    })
                    let fileName = 'Export_License_' + new Date().toGMTString() + '.xls'
                    this.exportToXSL(jsonData, fileName)
                }));

                
            })

           
            
           
        })
    }

    exportToXSL(jsonData, fileName) {
        let ws_name = 'Export'
        let ws = XLSX.utils.json_to_sheet(jsonData)

        // create a new workbook
        let wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, ws_name)

        // then save in XLS 2003 excel binary format so it will be super compatible!
        let type = 'biff8'
        XLSX.writeFile(wb, fileName || 'SheetJSTableExport.' + (type || 'xlsx'))
    }




    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <WhiteBox>
                                <div className="row">
                                    <div className="col">
                                        <h3>Filter licenses</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="add-segment add-segment--search-field">
                                            <input
                                                className="form-control"
                                                placeholder="Start typing a license name, a license id, an audience name or a Seat ID..."
                                                value={this.state.filter}
                                                onChange={({ target }) => this.onFilterChange(target)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>

                    {this.state.loading && this.state.licenses.length === 0 ? (
                        <Preloader transparent />
                    ) : (
                        <div className="row">
                            <div className="col-lg-12">
                                <WhiteBox>
                                    <div className="row">
                                        <div className="col-2">
                                            <h3>Your licenses</h3>
                                        </div>
                                        <div className="col text-right">
                                            <ACLCheckPermission api="/license" method="POST">
                                                <ReactTooltip id="createLicenseBtnTooltip" type="dark" effect="solid">
                                                    <span>Create a new License</span>
                                                </ReactTooltip>
                                                <button
                                                    data-tip
                                                    data-for="createLicenseBtnTooltip"
                                                    className="border-button inlinebuttons"
                                                    onClick={this.props.goNewLicense}>
                                                    NEW LICENSE
                                                </button>
                                            </ACLCheckPermission>
                                            &#160;
                                            <ACLCheckPermission api="/license/bulk" method="POST">
                                                <ReactTooltip id="bulkcreateBtnTooltip" type="dark" effect="solid">
                                                    <span>Bulk Create Licenses</span>
                                                </ReactTooltip>
                                                <button
                                                    data-tip
                                                    data-for="bulkcreateBtnTooltip"
                                                    className="border-button inlinebuttons"
                                                    onClick={this.props.onCreateLicenseBulk}>
                                                    BULK LICENSE
                                                </button>
                                            </ACLCheckPermission>

                                            <ReactTooltip id="exportLicenseBtnTooltip" type="dark" effect="solid">
                                                <span>Export as Excel XLS File (MAX 20k items)</span>
                                            </ReactTooltip>
                                            &#160;
                                            <button
                                                className="border-button inlinebuttons "
                                                data-tip
                                                data-for="exportLicenseBtnTooltip"
                                                href="#"
                                                onClick={() => this.onCSVExport()}>
                                                <i className="fa fa-file-excel-o fa-3" style={{ fontSize: '20px', top: '2px', position: 'relative' }}></i>&#160; Export

                                                {this.state.loading && (
                                                    <span className="login-loading-wrapper">
                                                        &#160;<i className="fa fa-spin fa-spinner" />
                                                    </span>
                                                )}


                                            </button>
                                            {/* render only if we have csv data */}
                                            {this.state.csvData != null && <CSVDownload filename={'export.csv'} data={this.state.csvData} />}
                                            
                                        </div>
                                    </div>
                                    {this.state.loading || this.state.licenses.length > 0 ? (
                                        <div>
                                            {!this.state.loading && this.state.saveStatus == 'togglingStatus' && <Preloader transparent />}

                                            <div class="table-responsive">
                                                <LicenseList
                                                    licenses={this.state.licenses}
                                                    getAudience={this.props.getAudience}
                                                    onLoadMore={this.onLoadMore.bind(this)}
                                                    loading={this.props.loading}
                                                    onEdit={id => this.onEditLicense(id)}
                                                    onHistory={this.onHistory.bind(this)}
                                                    sort={this.state.sort}
                                                    sortOrder={this.state.sortOrder}
                                                    onSortChange={this.onSortChange.bind(this)}
                                                    size={this.state.size}
                                                    offset={this.state.offset}
                                                    onShowEdit={this.state.showEdit}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row-reverse',
                                                margin: '60px 40px'
                                            }}>
                                            <img src="/img/license/illy-create-first-license.svg" alt="" />
                                        </div>
                                    )}
                                </WhiteBox>
                            </div>
                        </div>
                    )}
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        goNewLicense: () => push('/licenses/new'),
        goEditLicense: license => {
            /*push(`/licenses/edit/${license.licenseId}`, license)*/
        },
        onCreateLicenseBulk: () => push('/licenses/bulk-create')
    }
)(License)
